module.exports = __webpack_public_path__ + "img/headshot.9b1cf610.png";